import React from 'react';
import SLAEvent from './SLAEvent';
import AppointmentEvent from './AppointmentEvent';
import NewAppointment from './NewAppointment';
import BlockEvent from './BlockEvent';

const getComponent = (eventType) => {
  switch (eventType) {
    case 'SLA_EVENT':
      return SLAEvent;
    case 'NEW_EVENT':
      return NewAppointment;
    case 'BLOCK_EVENT':
      return BlockEvent;
    default:
      return AppointmentEvent;
  }
};

const EventComponent = (props) => {
  const Component = getComponent(props?.event?.eventType);
  return (
    <div
      className="event-component-style-wrapper full-height"
      id="event-component-style-wrapper"
    >
      <Component {...props} />
    </div>
  );
};

export default EventComponent;
